<div class="component-container">
  <section class="component-header">
    <h2>Trailers</h2>
  </section>
  <ng-container>
    <div class="search-bar">
      <form #searchForm="ngForm">
        <div class="form-group" *ngIf="selectedSearchOption === 'status'">
          <label class="form-label">Status</label>
          <select class="form-input" [(ngModel)]="pageSearchParams.search" name="statusOption"
            (change)="statusDropDownSearch()">
            <option *ngFor="let status of trailerStatus" [value]="status">{{
              status
              }}</option>
          </select>
        </div>
        <div class="form-group" *ngIf="selectedSearchOption !== 'status'">
          <label class="form-label">Search</label>
          <input class="form-input" type="text" name="searchQuery" [(ngModel)]="pageSearchParams.search"
            (input)="statusDropDownSearch()" />

        </div>
        <div class="form-group">
          <label class="form-label">Parameter</label>
          <select class="form-input" [(ngModel)]="selectedSearchOption" name="searchOption">
            <option *ngFor="let option of searchOptions" [value]="option.value">{{
              option.display
              }}</option>
          </select>
        </div>
      </form>
    </div>
    <div class="yard-display-holder">
      <ul class="yard-list">

        <li *ngFor="let trailer of page.data; let i = index;" class="yard-item">
          <div class="location-card">
            <section class="trailer-icon">
              <mat-icon class="truck-status" [ngStyle]="setTruckStatus(trailer)">local_shipping</mat-icon>
            </section>
            <div class="objects-section">
              <div class="content-holder">
                <p><strong>PO: </strong>{{ trailer?.po || "No data"}}</p>
                <p><strong>Trailer number: </strong>{{ trailer?.trailer || "No data"}}</p>
                <p><strong>Carrier: </strong>{{ trailer?.carrier || "No data"}}</p>
                <p><strong>Status: </strong>{{ trailer?.status || "No data"}}</p>
                <p><strong>Location: </strong>{{ trailer?.location || "No data"}}</p>
                <section *ngIf="trailer.location !== 'LOST'" class="trailer-options">
                  <button matTooltip="Check out" mat-raised-button color="warn" (click)="checkoutTrailer(i)">
                    <mat-icon>check_circle</mat-icon>
                  </button>
                  <button matTooltip="Mark lost" mat-raised-button color="accent" (click)="markTrailerLost(i)">
                    <mat-icon>error</mat-icon>
                  </button>
                </section>
                <section *ngIf="trailer.location === 'LOST'" class="lost-trailer-options">
                  <div class="form-group">
                    <label class="form-label">Empty locations</label>
                    <select class="form-input" #selectedEmptyLocation>
                      <option *ngFor="let yard of emptyYardPage.data; let j = index;" [value]="j">
                        {{ yard.location }}
                      </option>
                    </select>
                  </div>
                  <button [disabled]="emptyYardPage.data.length === 0 || selectedEmptyLocation.value === undefined" matTooltip="Assign location"
                    mat-raised-button color="primary" (click)="assignLostTrailer(trailer, selectedEmptyLocation.value)">
                    <mat-icon>done</mat-icon>
                  </button>
                </section>

              </div>
            </div>

          </div>
        </li>
      </ul>
      <mat-paginator #paginator *ngIf="page?.data?.length !== 0" (page)="handlePageEvent($event)"
        [length]="page.totalItems" [pageSize]="pageSearchParams.size" [showFirstLastButtons]="true"
        [pageSizeOptions]="pageSizeOptions" [pageIndex]="page.currentPage" aria-label="Select page">
      </mat-paginator>

    </div>
  </ng-container>
</div>